import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { Currency } from '@/shared/types/currency';

import type { TradingPlatformSessionSchema } from '../types/trading-platform-session.schema';

const initialState: TradingPlatformSessionSchema = {
    accountId: null,
    connectionType: null,
    currency: Currency.USD,
};

export const tradingPlatformSessionSlice = createSlice({
    name: 'tradingPlatformSession',
    initialState,
    reducers: {
        setConnectionSessionData: (
            state,
            action: PayloadAction<
                Pick<
                    TradingPlatformSessionSchema,
                    'connectionType' | 'accountId'
                >
            >,
        ) => {
            state.accountId = action.payload.accountId;
            state.connectionType = action.payload.connectionType;
        },
        setConneciontSessionCurrency: (
            state,
            action: PayloadAction<Currency>,
        ) => {
            state.currency = action.payload;
        },
        recconect: (state) => {
            state.accountId = null;
            state.connectionType = null;
            state.currency = null;
        },
    },
});

export const {
    actions: tradingPlatformSessionActions,
    reducer: tradingPlatformSessionReducer,
} = tradingPlatformSessionSlice;
